import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import { NoteService } from "src/app/services/note.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { CurrencyFormaterPipe } from "src/app/pipes/currencyReduce.pipe";
import { BrowserStorageService } from "src/app/services/storage.service";
import { RequestResponse } from "src/app/intefaces/requestResponse";
import { MessageService } from "primeng/api";
import { HttpAlertService } from "src/app/services/http-alert.service";
import { INote } from "src/app/intefaces/INote";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-add-notes",
  templateUrl: "./add-notes.component.html",
  styleUrls: ["./add-notes.component.scss"],
})
export class AddNotesComponent implements OnInit {
  public loading: boolean = false;
  public addNoteForm: FormGroup;
  public headerNotes = "";
  public _url = environment.endpoint + environment.apiPath;
  public noteFiles: Array<any> = [];
  public previewFiles: Array<any> = [];
  public soundFiles: Array<any> = [];
  public loader: boolean;
  public category: any;
  public note: INote;
  public categoryEdit;
  private currencyFormaterPipe: CurrencyFormaterPipe;
  public noteLevel: number = 1;
  public saving = false;
  public sample_audioWithUrl: string;
  public profit: string = "0.00";
  public waitForCalculate = false;

  constructor(
    private fb: FormBuilder,
    private noteService: NoteService,
    private router: Router,
    private route: ActivatedRoute,
    private browserStorageService: BrowserStorageService,
    private alertService: HttpAlertService,
    private translateService: TranslateService
  ) {
    this.currencyFormaterPipe = new CurrencyFormaterPipe(browserStorageService);
    this.note = {
      composer: "",
      created_at: "",
      description: "",
      is_active: true,
      is_folk: false,
      is_public: false,
      level: 0,
      music_author: "",
      offerts_count: 0,
      preview: '',
      price: 0,
      sample_audio: null,
      text_author: "",
      title: "",
      user_id: null,
    };
  }
  private id: number = null;
  private sub: Subscription;

  ngOnInit(): void {
    this._init();
  }

  private _init() {
    this.initForm();
    this.sub = this.route.params.subscribe((page) => {
      if (page.id) {
        this.loader = true;
        this.id = parseInt(page.id);
        this._initEdit(this.id);
      }
    });
  }

  public onSelectCategory(event) {
    this.category = event;
    const cat = event.map((event) => event.id);
    this.addNoteForm.get("category").setValue(cat);
  }

  private _initEdit(id) {
    this.noteService.getEditNoteById(id).subscribe((data) => {
      data.data.price = this.currencyFormaterPipe.transform(data.data.price);
      this.addNoteForm.patchValue(data.data);
      this.note = data.data;
      this.categoryEdit = data.data.categories.map((c) => c.category_note_id);
      this.addNoteForm.get("category").setValue(this.categoryEdit);
      this.noteLevel = data.data.level;
      this.loader = false;

      this.noteFiles.push({
        name: data.data.sources[0].file_name,
      });

      this.soundFiles.push({
        name: data.data.sample_audio,
      });

      if(data.data.preview) {
        this.previewFiles.push({
          name: data.data.preview,
        });
      }



      this.sample_audioWithUrl = `${environment.soundUrl}/${this.note.sample_audio}`;
      this.calculatePrice();
    });
  }

  private initForm() {
    this.addNoteForm = this.fb.group({
      title: ["", Validators.required],
      price: [null, Validators.required],
      pathSound: null,
      pathNote: null,
      preview: null,
      description: [""],
      composer: ["", Validators.required],
      music_author: ["", Validators.required],
      text_author: ["", Validators.required],
      category: [null, Validators.required],
      level: this.noteLevel,
      id: null,
      is_active: [true],
      is_folk: [false],
    });
  }

  public onUploadNote(event) {
    const body: RequestResponse = event.originalEvent.body;
    const fileStored = body.data.file;
    const filename = event.files[0].name;
    const obj = {
      file: fileStored,
      filename: filename,
    };
    this.addNoteForm.get("pathNote").setValue(obj);

    for (let file of event.files) {
      this.noteFiles.push(file);
    }
  }

  public onUploadPreview(event) {
    const body: RequestResponse = event.originalEvent.body;
    const fileStored = body.data.file;
    const filename = event.files[0].name;
    const obj = {
      file: fileStored,
      filename: filename,
    };
    this.addNoteForm.get("preview").setValue(obj);

    for (let file of event.files) {
      this.previewFiles.push(file);
    }
  }

  public onRemoveUploadedNote() {
    this.noteFiles = [];
  }

  public onRemoveUploadedPreview() {
    this.previewFiles = [];
    this.addNoteForm.get("preview").setValue(null);
  }

  public onUploadSound(event) {
    const body: RequestResponse = event.originalEvent.body;
    const fileStored = body.data.file;

    this.addNoteForm.get("pathSound").setValue(fileStored);
    for (let file of event.files) {
      this.soundFiles.push(file);
    }
    this.sample_audioWithUrl = `${environment.soundUrl}/${fileStored}`;
  }

  public handleLevelChange(l) {
    this.noteLevel = l;
    this.addNoteForm.patchValue({ level: l });
  }

  public onChangePrice(event: KeyboardEvent) {
    this.calculatePrice();
  }

  private calculatePrice() {
    const sendData = {
      gross_value: this.addNoteForm.get("price").value * 100,
    };
    this.noteService.getArrangerGrossCommision(sendData).subscribe(
      (response) => {
        this.profit = response.data.commission.brutto_value;
      },
      () => {
        this.waitForCalculate = false;
      }
    );
  }

  onSubmit() {
    if (this.addNoteForm.valid && this.noteFiles.length > 0) {
      this.saving = true;
      this.save();
    } else {
      this.alertService.error(this.translateService.instant("note_validate"));
    }
  }

  private save() {
    this.noteService.addNote(this.addNoteForm.value).subscribe(
      (data) => {
        this.addNoteForm.get("id").setValue(data.data.id);
        this.saving = false;
        this.router.navigate(['/my-account/success']);
      },
      () => {
        this.alertService.error(
          this.translateService.instant("notes_not_save_info_error")
        );
        this.saving = false;
      }
    );
  }

  public onDeleteNote(note) {
    if(confirm(this.translateService.instant('delete_note_confirm'))) {
      this.noteService.deleteNote(note).subscribe(
        (data) => {
          this.router.navigate(['/my-account/note-list']);
        });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
